module.exports = __webpack_public_path__ + "static/media/es-flag.42487f8e.png";